'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPlaneOutline = function TiPlaneOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 20.7l-8.3-4.8v-8c0-3.2-2.7-5.8-5.9-5.8s-5.8 2.6-5.8 5.8v8l-8.3 4.8c-2.2 1.2-3.1 3.9-2.1 6.2 0.9 2.4 3.5 3.6 5.9 2.9l4.5-1.3v1.4l-1.5 1.2c-2 1.6-2.4 4.4-1 6.6 1.3 2.1 4.1 2.9 6.4 1.8 0 0 0.8-0.3 1.9-0.3s2 0.3 2 0.3c2.3 1.1 5 0.4 6.4-1.8 1.4-2.2 0.9-5-1.1-6.6l-1.4-1.2v-1.4l4.4 1.3c2.5 0.7 5-0.5 6-2.9s0.1-5-2.1-6.2z m-1 4.9c-0.3 0.8-1.1 1.2-2 1l-8.7-2.5v7.4l2.7 2.2c0.7 0.5 0.9 1.5 0.4 2.2-0.5 0.7-1.4 1-2.1 0.6-0.1 0-1.4-0.7-3.5-0.7s-3.4 0.7-3.4 0.7c-0.8 0.4-1.7 0.1-2.1-0.6-0.5-0.7-0.3-1.7 0.3-2.2l2.7-2.2v-7.4l-8.7 2.5c-0.8 0.2-1.6-0.2-2-1-0.3-0.7 0-1.6 0.7-2l10-5.8v-9.9c0-1.4 1.2-2.5 2.5-2.5s2.5 1.1 2.5 2.5v9.9l10 5.8c0.8 0.4 1.1 1.3 0.7 2z m-12.3-18.1c0 0.5-0.4 0.8-0.9 0.8s-0.8-0.3-0.8-0.8c0-0.5 0.4-0.8 0.8-0.8s0.9 0.3 0.9 0.8z' })
        )
    );
};

exports.default = TiPlaneOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/plane-outline.js
// module id = 1976
// module chunks = 0